import React, { useState, useEffect, Suspense, lazy } from "react";
import { PricingTable } from "section/PricingTableSection";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClose,
  faMinus,
  faPlus,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { handleAllExcelDownload } from "utils/excelUtils";
import DeleteComponent from "components/DeleteComponent";
import FormComponent from "section/FormComponent";
import Loading from "components/Event/Loading";
import { uniqueIdGen } from "../../utils/pricingUtils";
import "./Pricing.css";

import {
  // goldOptions,
  // silverOptions,
  // platinumOptions,
  factoryCodeList,
  unitList,
  metalColorList,
  currencyList,
  internalQulityList,
  subAreaConfigurations,
} from "content/static.js";

import {
  quatationAdd,
  quatationEdit,
  quotationDmsDiamondQuality,
  getQuotation,
  styleNoQuotationDelete,
  userCustomerList,
  getPricingLotList,
  userMasterActiveList,
  deleteChainFromStoneDetail,
  quotationMetalLotCode,
  internationalQuality,
  deleteLabourBreakup,
  reCalculateLabourBreakup,
} from "api";

// import CommonAlert from "components/Alert";
const ProcessModal = lazy(() => import("components/ProcessModal"));
//=======================================================================================================================//

const Pricing = () => {
  const [checked, setChecked] = useState(false);
  const [isDisable, setIsDisable] = useState(false);
  const [isTwoTone, setIsTwoTone] = useState(false);
  const [LastName, setLastName] = useState("");
  const { pricingNo } = useParams();
  const [, /*showData */ setShowData] = useState(false);
  const [data, setData] = useState([]);
  const [, /*error */ setError] = useState(null);
  const [goldButtonText, setGoldButtonText] = useState("GM");
  const [goldRate, setGoldRate] = useState(); // State to store gold rate
  const [silverRate, setSilverRate] = useState(); // State to store gold rate
  const [platinumRate, setPlatinumRate] = useState(); // State to store gold rate
  const [palladiumRate, setPalladiumRate] = useState();
  const [silverButtonText, setSilverButtonText] = useState("GM");
  const [palladiumButtonText, setPalladiumButtonText] = useState("GM");
  const [selectedFactoryCode, setSelectedFactoryCode] = useState("");
  const [subArea, setSubarea] = useState(1);
  const [metalLotCodeList, setMetalLotCodeList] = useState([]);
  const [selectedDiamondQualityValue, setSelectedDiamondQualityValue] =
    useState([]); // eslint-disable-next-line
  const [selectedInternationalQuality, setSelectedInternationalQuality] =
    useState([]);
  const [selectedColorStone, setSelectedColorStone] = useState(null);
  const [platinumButtonText, setPlatinumButtonText] = useState("GM");
  const [selectedCurrency, setSelectedCurrency] = useState("USD");
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [diamondQualityOptionList, setDiamondQualityOptionList] = useState([]); // eslint-disable-next-line
  const [lotCode1, setLotCode1] = useState("");
  const [lotCode2, setLotCode2] = useState("");
  const [inputData, setInputData] = useState();
  const [selectedMetalColor, setSelectedMetalColor] = useState(""); // Initialize selectedMetalColor state
  const [selectedMetalKaratage, setSelectedMetalKaratage] = useState(""); // Initialize selectedMetalKaratage state
  const [selectedRadio, setSelectedRadio] = useState("STYLE");
  const [qualityFlag, setQualityFlag] = useState(undefined);
  const [selectedQualityRadio, setSelectedQualityRadio] =
    useState("INTERNALQUALITY");
  const [selectedQualityTitle, setSelectedQualityTitle] =
    useState("InternalQuality");
  const [pricingDate, setPricingDate] = useState(moment().format("DD-MM-YYYY"));
  const [priceDetails, setPricingDetails] = useState([]);
  const [, /*maxCts */ setMaxCts] = useState("");
  const [, /*stoneDetails */ setstoneDetails] = useState();
  const [withoutDetails, setWithoutDetails] = useState("");
  const [customerOptions, setCustomerOptions] = useState([]);
  const [isClosing, setIsClosing] = useState(false);
  const [isFormMinimized, setIsFormMinimized] = useState(false);
  const [deletestoneDetails, setDeletestoneDetails] = useState([]);
  const [updatedUniquePriceNumber, setUpdatedUniquePriceNumber] =
    useState(undefined);
  const [quotationIdToDelete, setQuotationIdToDelete] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const showLabourModal = false; // eslint-disable-next-line
  const [labourDetail, setLabourDetails] = useState([]);
  const [metalColours, setMetalColours] = useState([]);
  const [errorDetails, setErrorDetails] = useState(null);
  const [logged, setLogged] = useState({
    loggedCscId: undefined,
    loggedSubareaId: undefined,
    loggedCscName: undefined,
  });
  const [showModal, setShowModal] = useState(false);
  const [modalContentData, setModalContentData] = useState([]);
  const [allDataLoaded, setAllDataLoaded] = useState(false);
  const [rawInputData, setRawInputData] = useState("");
  const [styleCount, setStyleCount] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line
  const [validated, setValidated] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});
  const [selectedQualityValue, setSelectedQualityValue] = useState("");
  const [lotCode1Commodity, setLotCode1Commodity] = useState("");
  const [lotCode2Commodity, setLotCode2Commodity] = useState("");
  const [lotCodeList, setLotCodeList] = useState([]);
  const [groupValue, setGroupValue] = useState(false);
  const [labourLoader, setLabourLoader] = useState(false);
  let styleNoArray;
  const { user } = useSelector((state) => state.auth);
  //=======================================================================================//
  const eisId = user.eisId;
  //======================================================================================//

  const handleGoldDropdownChange = (newButtonText) => {
    setGoldButtonText(newButtonText);
  };

  const handleSilverDropdownChange = (newButtonText) => {
    setSilverButtonText(newButtonText);
  };

  const handlePlatinumDropdownChange = (newButtonText) => {
    setPlatinumButtonText(newButtonText);
  };

  const handlePaladiumDropdownChange = (newButtonText) => {
    setPalladiumButtonText(newButtonText);
  };

  //=======================================================================================//

  const fetchData = async (value) => {
    try {
      const responseData = await getQuotation({ pricingNo: value }).then(
        (response) => response.data
      );

      if (responseData.data && responseData.data) {
        // console.log("responseData===", responseData.data);
        const firstData = responseData.data;
        styleNoArray = firstData.priceDetails.map((detail) => detail.styleNo);
        setStyleCount(styleNoArray.length);
        setData(responseData);
        setDeletestoneDetails(responseData.data);
        setSelectedCustomer(firstData.customerCode);
        setLotCode1Commodity(firstData.lotCode1Commodity);
        setGoldRate(firstData.goldRate);
        setSilverRate(firstData.silverRate);
        setPlatinumRate(firstData.platinumRate);
        setPalladiumRate(firstData.palladiumRate);
        setSelectedCurrency(firstData.currency);
        setSelectedRadio(firstData.pricingFor);
        setUpdatedUniquePriceNumber(firstData.pricingNo);
        setLabourDetails(firstData.priceDetails);
        setPricingDate(firstData.updatedAt.split("T")[0]);
        handleGoldDropdownChange(firstData.goldUnit || "GM");
        handleSilverDropdownChange(firstData.silverUnit || "GM");
        handlePlatinumDropdownChange(firstData.platinumUnit || "GM");
        handlePaladiumDropdownChange(firstData.paladiumUnit || "GM");
        setSelectedFactoryCode(firstData.factoryCode);
        // const valuesArray = firstData.internalQuality.split("~");
        // const optionsArray = valuesArray.map((value, index) => ({
        //   label: value.trim(), // Trim to remove extra spaces
        //   value: value.trim(), // Use  as a unique value
        // }));

        setLogged({
          loggedCscId: firstData.loggedCscId,
          loggedSubareaId: firstData.loggedSubareaId,
          loggedCscName: firstData.loggedCsc,
        });
        // update form data
        setSubarea(firstData.loggedSubareaId);
        // setSelectedDiamondQuality(optionsArray);
        await handleQualityDetails({ value: firstData.customerCode });
      } else {
        console.error("Invalid response format: Data not found");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //=====================================================================================//
  const updateMetalColours = () => {
    let colors = [];
    if (goldRate) {
      colors = [...metalColorList];
    } else if (silverRate || platinumRate) {
      const whiteObj = metalColorList[1]; // white color metal obj
      colors = [whiteObj];
    }
    if (colors.length > 0) {
      setSelectedMetalColor("");
    }
    setMetalColours(colors); // Use Set to ensure unique values
  };

  //====================================================================================//

  const resetValuesToDefault = () => {
    const defaultConfig = {
      factoryCode: "CNPY_C02",
    };

    const selectedConfig = subAreaConfigurations[subArea] || defaultConfig;
    setSelectedFactoryCode(selectedConfig.factoryCode);
    setSelectedCurrency(selectedConfig.currency || "");
    setGoldButtonText(selectedConfig.goldButtonText);
    setSilverButtonText(selectedConfig.silverButtonText);
    setPlatinumButtonText(selectedConfig.platinumButtonText);
    setSelectedRadio(selectedConfig.selectedRadio);
    // setSelectedQualityRadio(selectedConfig.selectedQualityRadio)
    updateMetalColours();
  };

  //========================================================================================//

  // Effect for fetching data based on pricingNo
  useEffect(() => {
    if (pricingNo) {
      const parts = pricingNo.split("=");
      if (parts.length > 1) {
        const value = parts[1];
        fetchData(value);
      } else {
        console.error('Invalid format: The string does not contain "="');
      }
    }
  }, [pricingNo]);

  // Effect for setting logged and subarea states from localStorage
  useEffect(() => {
    const subAreaFromLocalStorage = localStorage.getItem("loggedSubareaId");
    setLogged({
      loggedCscId: localStorage.getItem("loggedCscId"),
      loggedSubareaId: localStorage.getItem("loggedSubareaId"),
      loggedCscName: localStorage.getItem("loggedCscName"),
    });
    setSubarea(parseInt(subAreaFromLocalStorage, 10));
    resetValuesToDefault();
  }, [subArea, subAreaConfigurations]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setErrorDetails(false);
    }, 5000);

    return () => clearTimeout(timeoutId);
  }, [errorDetails]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    //   // updateMetalColours();
    handleKarateList();
  }, [goldRate, silverRate, platinumRate, palladiumRate]); // eslint-disable-line react-hooks/exhaustive-deps

  //==================================================================================//

  const setErrorHandle = (name, value) => {
    setErrorMessage({ ...errorMessage, [name]: value });
  };

  const handleQualityDetails = async (selectedOption) => {
    try {
      if (!selectedOption) {
        setSelectedCustomer(null);
        setDiamondQualityOptionList([]);
        setErrorHandle("customerCode", "Please Select customerCode");
        setSelectedQualityValue(null);
        setSelectedInternationalQuality("");
        return;
      }

      setErrorHandle("customerCode", undefined);
      setSelectedCustomer(selectedOption);
      const { value: customerCode, lastName } = selectedOption;
      setLastName(lastName);

      const requestBody = { customerCode: customerCode };
      const fetchDmsDiamondQuality = quotationDmsDiamondQuality(requestBody);

      const [dmsDiamondQualityResponse] = await Promise.all([
        fetchDmsDiamondQuality,
      ]);
      const { data } = dmsDiamondQualityResponse;

      if (data && data.data) {
        const transformedOptions = data.data.map((value) => ({
          value: value.DiamondQualityChart,
          label: value.DiamondQualityChart,
        }));

        setDiamondQualityOptionList(transformedOptions);
        setSelectedQualityValue({ label: "Group", value: "QUALITYGROUP" });
        setQualityFlag(1);
        setIsDisable(false);
      } else {
        setDiamondQualityOptionList([]);
        setSelectedQualityValue(null);
      }
    } catch (error) {
      console.error("API error:", error);
    }
  };

  //==================================================================================//

  const handleRadioChange = (e) => {
    setSelectedRadio(e.target.value);
  };

  const handleQualityRadioChange = async (selectedOption) => {
    if (selectedOption.value === "INTERNALQUALITY") {
      if (internalQulityList) {
        setDiamondQualityOptionList(internalQulityList);
        setSelectedQualityValue(selectedOption);
        setQualityFlag(2);
        setIsDisable(false);
        setGroupValue(true);
      } else {
        setDiamondQualityOptionList([]);
      }
    } else if (selectedOption.value === "INTERNATIONALQUALITY") {
      let internationalQualityRes = await internationalQuality();
      setSelectedQualityValue(selectedOption);

      if (
        internationalQualityRes &&
        internationalQualityRes.data &&
        internationalQualityRes.data.data
      ) {
        const internalQualityOptionsList = internationalQualityRes.data.data;
        const transformedOptions = internalQualityOptionsList.map((value) => ({
          value: value.InternationalQualityName,
          label: value.InternationalQualityName,
        }));
        setDiamondQualityOptionList(transformedOptions);
        setQualityFlag(3);
        setIsDisable(false);
        setGroupValue(true);
      } else {
        setDiamondQualityOptionList([]);
        setGroupValue(false);
      }
    } else if (selectedOption.value === "QUALITYGROUP") {
      handleQualityDetails(selectedCustomer);
      setSelectedQualityValue(selectedOption);
      setQualityFlag(1);
      setIsDisable(true);
      setGroupValue(false);
    }

    setSelectedQualityRadio(selectedOption.value);
  };

  const handleModalStatus = (styleNo, status, response) => {
    setModalContentData((modelContentData) => {
      return modelContentData.map((state) => {
        if (state.styleNo.trim() === styleNo.trim()) {
          return { styleNo, status, response };
        } else {
          return { ...state };
        }
      });
    });
  };

  //===============================================================================================================//

  const metalKarateList = async () => {
    let CommodityGroupRef_SuidList = [];
    let allListOptions = [];

    try {
      // Check each metal rate and add the corresponding CommodityGroupRef_Suid to the list
      if (goldRate) CommodityGroupRef_SuidList.push(44);
      if (silverRate) CommodityGroupRef_SuidList.push(46);
      if (platinumRate) CommodityGroupRef_SuidList.push(45);
      if (palladiumRate) CommodityGroupRef_SuidList.push(90);

      // Only make the API call if there are metal rates
      if (CommodityGroupRef_SuidList.length > 0) {
        let reqBody = {
          SubareaId: logged.loggedSubareaId,
          CommodityGroupRef_SuidList: CommodityGroupRef_SuidList,
        };
        let response = await quotationMetalLotCode(reqBody);

        allListOptions = response.data.data;
      }

      return allListOptions;
    } catch (error) {
      console.error("Error fetching metal lot code data:", error);
      throw error; // Re-throw the error to be caught by the caller
    }
  };

  const handleKarateList = async () => {
    try {
      const responseDetails = await metalKarateList();

      const arrayOfObjects = responseDetails.map((item) => ({
        label: `${item.Lotcode}`,
        value: `${item.Lotcode}`,
        commodity: `${item.CommodityGroupId}`,
      }));

      // Check if the new state is different from the current state
      if (JSON.stringify(arrayOfObjects) !== JSON.stringify(metalLotCodeList)) {
        setMetalLotCodeList(arrayOfObjects);
      }
    } catch (error) {
      console.error("Error handling blur event:", error);
      // Handle error or display a message to the user
    }
  };

  //===================================================================================================//

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    let errorDetailsObj = {};
    const errorMessages = {
      customerCode: "Please Select customerCode",
      metalRate: "Please Enter any one metalRate",
      inputData:
        selectedRadio === "STYLE"
          ? "Please Enter Style number"
          : selectedRadio === "DESIGN"
          ? "Please Enter Design number"
          : "Please Enter Contract number",
      selectedQualityValue: "Please select Quality Type",
      // diamondQuality:"please Select Quatliy",
      selectedDiamondQualityValue: "Please select Quality",
      lotCode1: "Please Enter LotCode1",
      lotCode2: "Please Enter LotCode2",
      pricingDate: "pricing Date is required",
    };

    // Check for errors
    if (!selectedCustomer || selectedCustomer === "") {
      errorDetailsObj = {
        ...errorDetailsObj,
        customerCode: errorMessages.customerCode,
      };

      setShowError(true);
    }
    if (!goldRate && !silverRate && !platinumRate && !palladiumRate) {
      errorDetailsObj = {
        ...errorDetailsObj,
        metalRate: errorMessages.metalRate,
      };
      setShowError(true);
    }
    if (!selectedQualityValue || selectedQualityValue === "") {
      errorDetailsObj = {
        ...errorDetailsObj,
        selectedQualityValue: errorMessages.selectedQualityValue,
      };
      setShowError(true);
    }
    if (!lotCode1 || lotCode1 === "") {
      errorDetailsObj = {
        ...errorDetailsObj,
        lotCode1: errorMessages.lotCode1,
      };
      setShowError(true);
    }
    if (isTwoTone) {
      if (!lotCode2 || lotCode2 === "") {
        // Only set the error if isTwoTone is true
        errorDetailsObj = {
          ...errorDetailsObj,
          lotCode2: errorMessages.lotCode2,
        };
        setShowError(true);
      }
      // console.log("fasle");
      setShowError(false);
    }

    if (!inputData || inputData === "") {
      errorDetailsObj = {
        ...errorDetailsObj,
        inputData: errorMessages.inputData,
      };
      setShowError(true);
    }
    // if (
    //   !selectedDiamondQuality ||
    //   selectedDiamondQuality === "" ||
    //   selectedDiamondQuality.length <= 0
    // ) {
    //   // console.log("vvvvvvvvvvvv",errorMessages.diamondQuality)
    //   errorDetailsObj = {
    //     ...errorDetailsObj,
    //     diamondQuality: errorMessages.diamondQuality,
    //   };
    //   setShowError(true);
    // }
    if (
      !selectedDiamondQualityValue ||
      selectedDiamondQualityValue === "" ||
      selectedDiamondQualityValue.length <= 0
    ) {
      errorDetailsObj = {
        ...errorDetailsObj,
        selectedDiamondQualityValue: errorMessages.selectedDiamondQualityValue,
      };
      setShowError(true);
    }
    if (
      !logged.loggedCscId ||
      !logged.loggedSubareaId ||
      !logged.loggedCscName
    ) {
      alert("csc id, csc name, and subarea id not defined");
    }
    // console.log("lotCode", lotCode2, lotCode1);
    if (
      selectedCustomer &&
      (goldRate || silverRate || platinumRate || palladiumRate) &&
      (isTwoTone ? lotCode2 && lotCode2 !== "" : true) &&
      lotCode1 &&
      inputData &&
      selectedQualityValue &&
      selectedDiamondQualityValue &&
      selectedDiamondQualityValue.length > 0 &&
      // selectedDiamondQuality &&
      logged.loggedCscId &&
      logged.loggedSubareaId &&
      logged.loggedCscName
    ) {
      // Clear all error messages if no errors found
      let errorMessageTemp = {};
      Object.keys(errorMessages).forEach((key) => {
        errorMessageTemp[key] = null;
      });
      setErrorMessage(errorMessageTemp);
      setShowError(false);

      // Hide modal regardless of error state
      setShowModal(false);
      // setShowModal(true);
      const styleNumbers = inputData.split(",");

      const styleNoArray = styleNumbers.map((state) => ({
        styleNo: state.trim(),
        status: "Not Yet to Started",
        response: {},
      }));

      setModalContentData(styleNoArray);

      let pricingNoTemp = updatedUniquePriceNumber;
      // // console.log("🚀 ~ handleFormSubmit ~ pricingNoTemp:", pricingNoTemp)
      for (let styleNo of styleNumbers) {
        try {
          let goldRateInt = parseInt(goldRate, 10);
          let silverRateInt = parseInt(silverRate, 10);
          let platinumRateInt = parseInt(platinumRate, 10);
          let palladiumRateInt = parseInt(palladiumRate, 10);
          const internalQualityArray = selectedDiamondQualityValue.map(
            (item) => item.value
          );

          const internalQualityString = internalQualityArray.join("~");

          handleModalStatus(styleNo, "Processing ...", {});

          let requestData = {
            internalQuality: internalQualityString /*selectedDiamondQuality */,
            colorStone: selectedColorStone || "",
            pricingNo: pricingNoTemp,
            currency: selectedCurrency,
            customerCode: selectedCustomer.value,
            factoryCode: selectedFactoryCode,
            loggedUserId: eisId,
            loggedCscId: logged.loggedCscId,
            loggedCsc: logged.loggedCscName,
            goldRate: goldRateInt,
            silverRate: silverRateInt,
            platinumRate: platinumRateInt,
            palladiumRate: palladiumRateInt,
            goldUnit: goldRateInt && goldButtonText,
            silverUnit: silverRateInt && silverButtonText,
            platinumUnit: platinumRateInt && platinumButtonText,
            palladiumUnit: palladiumRateInt && palladiumButtonText,
            pricingFor: selectedRadio,
            styleNo: styleNo.trim(),
            fromLot: checked === false ? "NO" : "YES", // fromLot flag
            qualityFlag: qualityFlag,
            isTwoTone: isTwoTone === true ? 1 : 0, //two tone flag
            lotCode1: lotCode1,
            lotCode2: lotCode2,
            lotCode1Commodity: lotCode1Commodity,
            lotCode2Commodity: lotCode2Commodity,
            pricingDate: pricingDate,
            aliasName: LastName,
          };

          setShowModal(true);
          if (logged.loggedCscId) {
            requestData = { ...requestData, ...logged };
          }

          const formData = new FormData();
          formData.append("requestData", JSON.stringify(requestData));

          pricingNoTemp = await quotationAddFunHandle(requestData, styleNo);
          // setLastSuccessfulPricingNo(pricingNoTemp);
          setUpdatedUniquePriceNumber(pricingNoTemp);
        } catch (error) {
          // console.log("Error::>>", error);
          setUpdatedUniquePriceNumber(pricingNoTemp);
        }
      }
      setShowData(true);
      setShowError(false);
    } else {
      setErrorMessage(errorDetailsObj);
    }
    //// console.log("errorDetailsObj", errorDetailsObj);
  };

  //=====================================================================================================//

  const quotationAddFunHandle = async (requestData, styleNo) => {
    let responseData;
    setAllDataLoaded(false);

    try {
      const response = await quatationAdd(requestData);
      responseData = response.data;

      if (responseData && responseData.data) {
        if (response.data.status === 400) {
          if (response.data.message === "Data Not Found") {
            setErrorDetails(response.data.message);
            handleModalStatus(styleNo, "Failed", {});
          } else if (response.data.message) {
            setErrorDetails(response.data.message);
            handleModalStatus(styleNo, "Failed", {});
          } else {
            // Handle other specific error cases
            // console.log("data========== 4000");
            setErrorDetails(response.data.message);
            handleModalStatus(styleNo, "Failed", {});
            console.error(
              "Invalid response data structure:",
              responseData.data
            );
          }
        } else if (response.data.status === 200) {
          if (responseData.data.priceDetails) {
            setDeletestoneDetails(responseData.data);
            // setUpdateDetails(responseData.data.priceDetails);
            setPricingDetails(responseData.data.priceDetails);
            setSelectedCustomer({
              value: responseData.data.priceDetails[0].customerCode,
            });
            setErrorDetails(null);
            handleModalStatus(
              styleNo,
              "Completed",
              responseData.data.priceDetails
            );
            const styleNoArray = responseData.data.priceDetails.map(
              (detail) => detail.styleNo
            );
            setStyleCount(styleNoArray.length);
          } else {
            // console.log("data========== 2000");
            console.error(
              "Invalid response data structure:",
              responseData.data
            );
          }
        }
        setWithoutDetails(responseData.data.message);
      } else {
        console.error("Invalid response data structure:", responseData);
        setErrorDetails("System Busy! Something went wrong");
        handleModalStatus(
          styleNo,
          "Failed",
          response.data.status === "400" ? {} : responseData.data.priceDetails
        );
      }
    } catch (error) {
      console.error("Error fetching data:>>>>", responseData.status === 400);
      let errorMessageToShow = "System Busy! Something went wrong"; // Default error message

      if (responseData.status === 400) {
        handleModalStatus(styleNo, "Failed", {});
        setErrorDetails(errorMessageToShow); // Set the error details
      }
      // handleModalStatus(styleNo, "Failed", {});
      // setErrorDetails(errorMessageToShow); // Set the error details
      // Show the modal with "Failed" status
    } finally {
      setAllDataLoaded(true); // Ensure that the data loading state is set to true
    }

    return responseData?.data?.priceDetails
      ? responseData.data.pricingNo
      : requestData.pricingNo;
  };

  const handleFactoryCodeChange = (e) => {
    setSelectedFactoryCode(e.target.value);
  };

  //================================================================================//

  const handleGoldRateChange = (e) => {
    if (e.target.value) {
      setErrorHandle("metalRate", undefined);
    }

    setGoldRate(e.target.value);
  };

  const handleSilverRateChange = (e) => {
    if (e.target.value) {
      setErrorHandle("metalRate", undefined);
    }
    setSilverRate(e.target.value);
  };

  const handlePlatinumRateChange = (e) => {
    if (e.target.value) {
      setErrorHandle("metalRate", undefined);
    }
    setPlatinumRate(e.target.value);
  };

  const handlePaladiumRateChange = (e) => {
    if (e.target.value) {
      setErrorHandle("metalRate", undefined);
    }
    setPalladiumRate(e.target.value);
  };
  //================================================================================//

  const handleRHSRateChange = (event, stoneDetail, detail) => {
    let updatedRHS = event.target.value;
    // console.log("🚀 ~ handleRHSRateChange ~ updatedRHS:", updatedRHS);

    updateDetailsInApi({
      stoneDetailId: stoneDetail._id,
      priceDetailId: detail._id,
      rhsRate: Number(updatedRHS),
      rhsMaxCts: Number(stoneDetail.rhsMaxCts),
    });
    stoneDetail.rhsRate = updatedRHS;
    const updatedRHSRateDetail = { ...detail };
    setstoneDetails(updatedRHSRateDetail);
  };

  const navigate = useNavigate();

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      navigateToPricingTable(); // Replace this with your actual closing logic.
    }, 500); // Adjust the timeout value to match the transition duration in CSS (0.5s in this example).
  };

  //===============================================================================//

  const navigateToPricingTable = () => {
    navigate("/PricingTable");
  };

  const updateDetailsInApi = async (updatedData) => {
    try {
      const response = await quatationEdit(updatedData);
      return response.data.data;
    } catch (error) {
      console.error("Error updating details:", error);
    }
  };

  const handleCustomerSelect = (selectedOption, { action }) => {
    if (action === "input-change" && selectedOption.length >= 4) {
      if (user.role === "user") {
        fetchCustomerUserList(selectedOption);
      } else {
        fetchCustomerAdminList(selectedOption);
      }
    }
  };

  //=======================================================================================//

  const fetchCustomerUserList = async (selectedOption) => {
    try {
      setIsLoading(true);
      const requestBody = {
        EmployeeId: eisId,
        // CSCId: logged.loggedCscId,
        //SubareaId: logged.loggedSubareaId
      };

      const response = await userCustomerList(requestBody);

      const options = response.data.data.map((item) => ({
        value: item.MappedCustomerCode,
        label: `${item.MappedCustomerCode} - [${item.CustomerAliasName}]`,
      }));
      setIsLoading(false);

      setCustomerOptions(options);
    } catch (error) {
      setError(error);
    }
  };

  const fetchCustomerAdminList = async (selectedOption) => {
    try {
      setIsLoading(true);
      const requestBody = {
        SubareaId: logged.loggedSubareaId,
      };

      const res = await userMasterActiveList(requestBody);
      const options = res.data.data.map((item) => ({
        value: item.CustomerCode,
        label: `${item.CustomerCode}`,
        // - [${item.LastName}]`,
        // lastName: item.LastName,
      }));
      setCustomerOptions(options);
      setIsLoading(false);
    } catch (error) {
      setError(error);
    }
  };

  //=======================================================================================//

  const handleDeleteClick = (deletestoneDetails, details) => {
    // Set the modal to be visible and store the quotationId to delete
    setShowDeleteModal(true);
    setQuotationIdToDelete({
      deletestoneDetails: deletestoneDetails,
      details: details,
    });
  };

  const handleConfirmDelete = async (e) => {
    e.preventDefault();
    setShowDeleteModal(true);
    try {
      let requestBody = {
        quotationId: `${quotationIdToDelete.deletestoneDetails._id}`,
        stoneDetailId: `${quotationIdToDelete.details._id}`,
      };
      const deleteRes = await styleNoQuotationDelete(requestBody);
      if (deleteRes) {
        const parts = pricingNo.split("=");
        const value = parts[1];
        await fetchData(value); // Wait for the data to be fetched
      } else {
        console.error("Invalid data structure after deletion:", deleteRes);
      }
    } catch (err) {
      console.error("Error Message", err);
    } finally {
      setShowDeleteModal(false);
      // setQuotationIdToDelete(null);
    }
  };

  const handleCancelDelete = () => {
    // Cancel the delete operation and close the modal
    setShowDeleteModal(false);
    setQuotationIdToDelete(null);
  };

  //========================================================================================//

  const handleLabourBreakup = (data) => {
    setLabourDetails(data);
  };

  const styleNohandle = (e) => {
    const inputValue = e.target.value;

    // Remove any leading/trailing spaces and commas
    const trimmedValue = inputValue.trim().replace(/(^,)|(,$)/g, "");

    // Split the input into lines by comma or space
    const lines = trimmedValue.split(/[,\s]+/);

    // Filter out empty lines and duplicates
    const uniqueStyleNumbers = [...new Set(lines.filter(Boolean))];

    // Limit the style numbers to 50
    const limitedStyleNumbers = uniqueStyleNumbers.slice(0, 50);

    // Update the input value with comma separated style numbers
    const formattedValue = limitedStyleNumbers.join(", ");

    // Update the input value in the text area
    e.target.value = formattedValue;

    // Update the state or perform any other action as needed
    setRawInputData(formattedValue); // Update the raw input data state
    setInputData(formattedValue);

    // Show error message if exceeded the maximum limit of 50 style numbers
    const messageElement = document.getElementById("errorMsg");
    if (uniqueStyleNumbers.length > 50) {
      messageElement.innerHTML =
        '<span class="error">Exceeded the maximum limit of 50 style numbers.</span>';
    } else {
      messageElement.innerHTML = "";
    }
  };

  const handleToggleMinimize = () => {
    setIsFormMinimized(!isFormMinimized);
  };

  //=======================================================================================//

  const handleChainStoneDelete = async (stoneDetails, deletestoneDetails) => {
    let requestBody = {
      stoneDetailsId: stoneDetails._id,
      pricingNo: deletestoneDetails.pricingNo,
    };
    let responseDel = await deleteChainFromStoneDetail(requestBody);
    if (responseDel.data.status === 200) {
      await fetchData(deletestoneDetails.pricingNo);
    } else {
      // console.log(responseDel.data.message);
    }
  };

  const handleAddToRow = async (stoneDetail, deletestoneDetails) => {
    // console.log("stoneDEtailsss", stoneDetail);

    const value = stoneDetail._id + 1;

    const newRow = {
      ...stoneDetail,
      _id: uniqueIdGen(stoneDetail), // Generate a new unique ID
    };

    const updatedDetail = deletestoneDetails.priceDetails.map((details) => {
      const updatedList = details.stoneDetails.reduce((acc, stone) => {
        if (stone._id === stoneDetail._id) {
          acc.push(newRow);
        }
        acc.push(stone);
        return acc;
      }, []);
      return {
        ...details,
        stoneDetails: updatedList,
      };
    });
    // // console.log("🚀 ~ updatedDetail ~ updatedDetail:", updatedDetail)

    setDeletestoneDetails((prevDetails) => ({
      ...prevDetails,
      priceDetails: updatedDetail,
    }));
  };

  const handleLabourDelete = async (
    priceDetail,
    laborBreakupDetail,
    deletestoneDetails
  ) => {
    try {
      let requestBody = {
        priceDetailsId: priceDetail._id,
        labourBreakupId: laborBreakupDetail._id,
      };

      const deleteResponse = await deleteLabourBreakup(requestBody);

      if (deleteResponse.data.status === 200) {
        // Update the labour data
        const updatedLabourData = deletestoneDetails.priceDetails.map(
          (detail) => {
            return {
              ...detail,
              labourBreakup: detail.labourBreakup.filter((labour) => {
                return labour._id !== laborBreakupDetail._id;
              }),
            };
          }
        );

        // Use the functional form of setState to ensure you have the latest state
        setDeletestoneDetails((prevDetails) => ({
          ...prevDetails,
          priceDetails: updatedLabourData,
        }));
      } else {
        // console.log(deleteResponse.data.message);
      }
    } catch (error) {
      console.error("Error deleting labour:", error);
    }
  };

  const disableInputAction =
    deletestoneDetails.priceDetails &&
    deletestoneDetails.priceDetails.length > 0;

  const handleCloseModal = () => {
    setShowModal(false);
  };

  //========================================================================================//

  const handleReCalculateLabour = async (
    priceDetailIdList,
    deletestoneDetails,
    keys
  ) => {
    try {
      if (keys === "singleLabour") {
        // Handle re-calculation for a single item
        const requestBody = {
          quotationId: deletestoneDetails._id,
          priceDetailIdList: [priceDetailIdList],
        };
        setLabourLoader(true);
        const recalculateLabourResponse = await reCalculateLabourBreakup(
          requestBody
        );
        // // console.log("🚀 ~ Pricing ~ recalculateLabourResponse:", recalculateLabourResponse)
        const updateLabourBreakup = deletestoneDetails.priceDetails.map(
          (detail) =>
            detail._id ===
            recalculateLabourResponse.data.updateLabourBreakup[0]?._id
              ? recalculateLabourResponse.data.updateLabourBreakup[0]
              : detail
        );
        // // console.log("🚀 ~ Pricing ~ updateLabourBreakup:", updateLabourBreakup)

        setDeletestoneDetails({
          ...deletestoneDetails,
          priceDetails: updateLabourBreakup,
        });
        setLabourLoader(false);
      } else {
        // Handle re-calculation for multiple items

        const stonesDetailsIds = deletestoneDetails.priceDetails?.map(
          (data) => data?._id
        );

        const requestBody = {
          quotationId: deletestoneDetails._id, // Assuming this should be an array of IDs
          priceDetailIdList: stonesDetailsIds,
        };

        const recalculateLabourResponse = await reCalculateLabourBreakup(
          requestBody
        );

        const quotationUpdatedDetails = deletestoneDetails?.priceDetails.map(
          (priceDetail) => {
            const updatedDetail =
              recalculateLabourResponse.data.updateLabourBreakup.find(
                (data) => data._id === priceDetail._id
              );

            if (updatedDetail) {
              // Replace old laborBreakup with new laborBreakup
              const updatedPriceDetail = {
                ...priceDetail,
                labourBreakup: updatedDetail.labourBreakup,
              };
              return updatedPriceDetail;
            } else {
              return priceDetail;
            }
          }
        );

        setDeletestoneDetails(quotationUpdatedDetails);
      }
    } catch (error) {
      console.error("Error recalculating labour:", error);
      // Handle error or display a message to the user
    }
  };

  const handleLotList = async (rmId, stoneDetail) => {
    const { comName, shapeCode, cutCode } = stoneDetail;
    let requestLotList;
    let customCodeValue;
    if (comName === "Metal" || comName === "Finding" || comName === "Chain") {
      if (cutCode === "Gold") {
        customCodeValue = 44;
      } else if (cutCode === "Silver") {
        customCodeValue = 46;
      } else if (cutCode === "Platinum") {
        customCodeValue = 45;
      } else if (cutCode === "Palladium") {
        customCodeValue = 90;
      }
      requestLotList = {
        SubareaId: logged.loggedSubareaId,
        rmId: rmId,
        commodity: customCodeValue,
      };

      // Set customCodeValue based on cust code
    } else {
      requestLotList = {
        SubareaId: logged.loggedSubareaId,
        rmId: rmId,
        ShapeCode: shapeCode,
      };
    }

    try {
      const responseLotList = await getPricingLotList(requestLotList);

      const updatedLotCodeList = responseLotList.data.data.map((item) => ({
        label: item,
        value: item,
      }));
      setLotCodeList(updatedLotCodeList);
    } catch (error) {
      // console.log("Error", error);
    }
  };

  const handleMaxCtsChange = async (
    event,
    stoneDetail,
    detail,
    quotationDetails,
    setDeletestoneDetails,
    keys
  ) => {
    try {
      if (keys === "rhsMaxCts") {
        const newMaxCts = event.target.value;
        await updateDetailsInApi({
          stoneDetailId: stoneDetail._id,
          priceDetailId: detail._id,
          rhsRate: stoneDetail.rhsRate,
          rhsMaxCts: Number(newMaxCts),
        });
        stoneDetail.rhsMaxCts = newMaxCts;
        const updatedMaxCtsDetail = { ...detail };
        setMaxCts(updatedMaxCtsDetail);
      } else {
        try {
          const temp = await updateDetailsInApi({
            stoneDetailId: stoneDetail._id,
            priceDetailId: detail._id,
            lotCode: event,
          });

          if (temp && temp.priceDetails && temp.priceDetails.length > 0) {
            const updateAllDetails = temp.priceDetails[0];

            const updateMainDetails = quotationDetails.priceDetails.map(
              (detail) =>
                detail._id === updateAllDetails._id ? updateAllDetails : detail
            );

            setDeletestoneDetails({
              ...quotationDetails,
              priceDetails: updateMainDetails,
            });
          } else {
            console.error("Invalid response from API:", temp);
          }
        } catch (error) {
          console.error("Error fetching data from API:", error);
        }
      }
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };

  const formComponentPropsList = {
    handleKarateList,
    groupValue,
    setGroupValue,
    handleReCalculateLabour,
    deletestoneDetails,
    setLotCode1Commodity,
    setLotCode2Commodity,
    setIsDisable,
    isDisable,
    isTwoTone,
    setIsTwoTone,
    selectedQualityValue,
    setSelectedQualityValue,
    lotCode1,
    lotCode2,
    setLotCode1,
    setLotCode2,
    setMetalLotCodeList,
    metalLotCodeList,
    checked,
    setChecked,
    handleFormSubmit,
    setSelectedQualityTitle,
    selectedQualityTitle,
    isFormMinimized,
    handleQualityDetails,
    handleCustomerSelect,
    customerOptions,
    selectedCustomer,
    handleFactoryCodeChange,
    factoryCodeList,
    selectedFactoryCode,
    handleGoldRateChange,
    goldRate,
    palladiumRate,
    handleGoldDropdownChange,
    goldButtonText,
    handleSilverRateChange,
    silverRate,
    handleSilverDropdownChange,
    silverButtonText,
    handlePlatinumRateChange,
    handlePaladiumRateChange,
    platinumRate,
    handlePlatinumDropdownChange,
    handlePaladiumDropdownChange,
    platinumButtonText,
    palladiumButtonText,
    selectedRadio,
    selectedQualityRadio,
    handleRadioChange,
    handleQualityRadioChange,
    rawInputData,
    setRawInputData,
    styleNohandle,
    setSelectedMetalKaratage,
    setSelectedMetalColor,
    setSelectedDiamondQualityValue,
    selectedDiamondQualityValue,
    selectedMetalKaratage,
    selectedMetalColor,
    diamondQualityOptionList,
    unitList,
    isLoading,
    disableInputAction,
    pricingNo,
    priceDetails,
    styleCount,
    data,
    updatedUniquePriceNumber,
    pricingDate,
    selectedCurrency,
    setSelectedCurrency,
    currencyList,
    setShowModal,
    setShowData,
    quotationAddFunHandle,
    logged,
    eisId,
    LastName,
    metalKarateList,
    metalColours,
    setPricingDate,
    validated,
    showError,
    errorDetails,
    errorMessage,
    setErrorHandle,
    setShowError,
  };

  //========================================================================================//
  return (
    <>
      <Suspense
        fallback={
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "100vh" }}
          >
            <Loading />
          </div>
        }
      >
        {/* {showError && (
            // <CommonAlert
            //   variant={`${error?.status === 200 ? "success" : "danger"}`}
            //   key={`${error?.status === 200 ? "success" : "danger"}`}
            //   message={`${
            //     error?.status === 200
            //       ? `${error?.message}`
            //       : `${error?.message}`
            //   }`}
            //   className="alert-right" // Apply custom CSS class for positioning
            // />
            <></>
          )} */}

        <ProcessModal
          showModal={showModal}
          modalContentData={modalContentData}
          allDataLoaded={allDataLoaded}
          handleCloseModal={handleCloseModal}
        />

        <div className="px-2 pt-2 pb-1">
          <div className={`pl-1 ${isClosing ? "closing" : ""} form-container`}>
            <div className="back-button-container mb-0">
              <div className="d-flex align-items-center">
                {deletestoneDetails.priceDetails?.length > 0 ? (
                  <h4 style={{ paddingTop: "5px", paddingBottom: "5px" }}>
                    Edit Quotation
                  </h4>
                ) : (
                  <h4 style={{ paddingTop: "5px", paddingBottom: "5px" }}>
                    Create Quotation
                  </h4>
                )}
                <div className="pl-3 pb-2">
                  {isFormMinimized &&
                    deletestoneDetails.priceDetails?.length > 1 && (
                      <div className="d-flex pl-3">
                        <div className="form-label pt-2">
                          {selectedRadio === "STYLE"
                            ? "Total Styles"
                            : " Total Designs"}{" "}
                          :<span className="form-label pl-1">{styleCount}</span>
                        </div>
                        <div className="pt-1">
                          <ActionBtn
                            exportAction={() => handleAllExcelDownload(data)}
                          />
                        </div>
                      </div>
                    )}
                </div>
              </div>
              <div style={{ marginLeft: "auto", marginRight: "15px" }}>
                <button
                  className="btn btn-minmax btn-sm mx-1"
                  onClick={handleToggleMinimize}
                >
                  {isFormMinimized ? (
                    <FontAwesomeIcon title="Maximize" icon={faPlus} size="lg" />
                  ) : (
                    <FontAwesomeIcon
                      title="Minimize"
                      icon={faMinus}
                      size="lg"
                    />
                  )}
                </button>

                <button className="btn btn_close btn-sm" onClick={handleClose}>
                  <FontAwesomeIcon title="Close" icon={faClose} size="lg" />
                </button>
              </div>
            </div>

            <FormComponent {...formComponentPropsList} />
          </div>
        </div>

        {errorDetails && (
          <div className="d-flex justify-content-center mt-5">
            <h5 style={{ color: "red" }}>Quotation not Found</h5>
          </div>
        )}

        {!pricingNo && !priceDetails && (
          <div className="d-flex justify-content-center pt-5">
            <h3 style={{ color: "red" }}>{withoutDetails} </h3>
          </div>
        )}

        <PricingTable
          handleReCalculateLabour={handleReCalculateLabour}
          lotCodeList={lotCodeList}
          handleLotList={handleLotList}
          deletestoneDetails={deletestoneDetails}
          setDeletestoneDetails={setDeletestoneDetails}
          isClosing={isClosing}
          handleLabourBreakup={handleLabourBreakup}
          handleDeleteClick={handleDeleteClick}
          handleMaxCtsChange={handleMaxCtsChange}
          handleRHSRateChange={handleRHSRateChange}
          handleChainStoneDelete={handleChainStoneDelete}
          handleAddToRow={handleAddToRow}
          handleLabourDelete={handleLabourDelete}
          showLabourModal={showLabourModal}
          labourLoader={labourLoader}
        />

        {showDeleteModal && (
          <DeleteComponent
            handleCancelDelete={handleCancelDelete}
            handleConfirmDelete={handleConfirmDelete}
          />
        )}
      </Suspense>
    </>
  );
};

const ActionBtn = ({ exportAction }) => (
  <FontAwesomeIcon
    type="button"
    title="Download All Excel"
    className="ml-3"
    icon={faDownload}
    size="lg"
    style={{ color: "black" }}
    onClick={exportAction}
  />
);

export default Pricing;
